import React from "react";
import { Button } from "@mui/material";
import { cssProperties } from "../../utils/commonCssProperties";

export default function OrangeButton({ title, type, handleSubmit,icon ,disabled,flag}) {

    return (
        <Button
            type={type}
            disableElevation
            variant="contained"
            sx={{
                cursor:flag=="true" ? 'default' : "pointer",
                borderRadius: '10px',
                padding: '0px 24px',
                height: '40px',
                backgroundColor: `#FFBF00`,
                fontSize: '14px',
                fontWeight: '600',
                lineHeight: '15.4px',
                letterSpacing: '0.32px',
                boxShadow: 'none',
                width:"130px",
                border: '1px solid transparent',
                "&:hover": {
                    backgroundColor: '#FFBF00', 
                },
                "&:focus": {
                    backgroundColor: '#FFBF00',
                },
                "&.Mui-disabled": {
                    backgroundColor: '#A5D6A7', 
                    color: 'white', 
                    opacity: 0.7, 
                    cursor: flag=="true" ? 'default' :'pointer', 
                }
                
            }}
            onClick={handleSubmit}
            startIcon={icon}
            disabled={disabled}
        >
            {title}
        </Button>
    )
}